// React Imports
import { ReactElement, useState } from "react";

// Third Party Libraries Imports
import { ColumnsType } from "antd/es/table";
import { Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";

// Local Imports
import CustomSearch from "../../components/custom-search/custom-search";
import CustomTable from "../../components/custom-table/custom-table";
import CustomModal from "../../components/custom-modal/custom-modal";
import DeleteModal from "../../components/delete-modal/delete-modal";

const PaciLogs: React.FC = (): ReactElement => {
  const navigate = useNavigate();
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [viewModal, setViewModal] = useState<boolean>(false);

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Request Id",
      dataIndex: "requestId",
      key: "requestId",
      sorter: (a, b) => a.requestId.length - b.requestId.length,
      fixed: "left",
    },
    {
      title: "Civil ID",
      dataIndex: "civilId",
      key: "civilId",
      sorter: (a, b) => a.civilId.length - b.civilId.length,
    },
    {
      title: "Name En",
      dataIndex: "nameEn",
      key: "nameEn",
      sorter: (a, b) => a.nameEn.length - b.nameEn.length,
    },
    {
      title: "Name Ar",
      dataIndex: "nameAr",
      key: "nameAr",
      sorter: (a, b) => a.nameAr.length - b.nameAr.length,
    },
    {
      title: "Birth date",
      dataIndex: "birthDate",
      key: "birthDate",
      sorter: (a, b) => a.birthDate.length - b.birthDate.length,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      sorter: (a, b) => a.gender.length - b.gender.length,
    },
    {
      title: "Contact",
      dataIndex: "contact",
      key: "contact",
      sorter: (a, b) => a.contact.length - b.contact.length,
    },
    {
      title: "Expire date",
      dataIndex: "expireDate",
      key: "expireDate",
      sorter: (a, b) => a.expireDate.length - b.expireDate.length,
    },
    {
      title: "Card serial",
      dataIndex: "serial",
      key: "serial",
      sorter: (a, b) => a.serial.length - b.serial.length,
    },
    {
      title: "Nationality",
      dataIndex: "nationality",
      key: "nationality",
      sorter: (a, b) => a.nationality.length - b.nationality.length,
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div className="flex items-center gap-3">
          <ReactSVG
            src={"/images/view.svg"}
            onClick={() => setViewModal(true)}
          />
          <ReactSVG
            src={"/images/edit.svg"}
            onClick={() => navigate(`/paci-logs/edit-paci/${record?.id}`)}
          />
          <ReactSVG
            className="delete-icon"
            src={"/images/delete.svg"}
            onClick={() => setOpenDeleteModal(true)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="completed-table">
      <div className="flex items-center justify-between rounded-lg bg-white py-[10px] px-5">
        <p className=" text-black-300 text-base font-bold">
          {[]?.length} PACI logs
        </p>
        <div className="images flex items-center">
          <CustomSearch />
          <Tooltip placement="topLeft" title="Columns settings">
            <img src={"/images/grid.svg"} alt="grid" />
          </Tooltip>
        </div>
      </div>
      <CustomTable columns={columns} data={[]} />

      <CustomModal
        isVisible={openDeleteModal}
        centered
        width={450}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        className="delete-modal"
      >
        <DeleteModal
          onCancel={() => setOpenDeleteModal(false)}
          text="Delete PACI log!"
          subText={`Are you sure you want to delete this PACI log?`}
        />
      </CustomModal>
    </div>
  );
};

export default PaciLogs;
